module.exports = __webpack_public_path__ + "img/help-active.f51826d1.svg";